import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'indicationSpecialtyTranslation'
})
export class IndicationSpecialtyTranslationPipe implements PipeTransform {

    constructor(private translate: TranslateService) {
    }

    transform(value: string): string {
        switch (value) {
            case 'OPHTHALMOLOGY':
                return this.translate.instant('ONBOARDING.EDUCATION.OPHTHALMOLOGY');
        }
        return value;
    }

}
